<template>
<svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')">
<path d="M5.15625 9.875C6.83899 9.875 8.20312 8.51087 8.20312 6.82812C8.20312 5.14538 6.83899 3.78125 5.15625 3.78125C3.47351 3.78125 2.10938 5.14538 2.10938 6.82812C2.10938 8.51087 3.47351 9.875 5.15625 9.875Z" :stroke="color" stroke-miterlimit="10"/>
<path d="M9.1062 3.89447C9.52528 3.77639 9.96479 3.74949 10.3951 3.81558C10.8255 3.88167 11.2367 4.03922 11.601 4.2776C11.9653 4.51598 12.2743 4.82968 12.5072 5.19754C12.7401 5.56541 12.8915 5.97892 12.9511 6.41021C13.0107 6.84149 12.9772 7.28055 12.8529 7.69781C12.7285 8.11506 12.5162 8.50082 12.2302 8.82911C11.9442 9.1574 11.5912 9.42059 11.1949 9.60095C10.7986 9.78132 10.3683 9.87467 9.93293 9.87472" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.937012 12.0662C1.41287 11.3893 2.0446 10.8369 2.77888 10.4555C3.51315 10.0741 4.3284 9.87503 5.15581 9.875C5.98322 9.87497 6.79849 10.074 7.53279 10.4553C8.26709 10.8367 8.89887 11.3891 9.37478 12.0659" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.93311 9.875C10.7606 9.8744 11.576 10.0732 12.3104 10.4546C13.0448 10.8359 13.6764 11.3886 14.1519 12.0659" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
  props: ['color']
}
</script>
